<div class="container">
    <div class="parties">
        <div class="fromParties">
            <div class="fromTxt">
                <b>From:</b>
            </div>
            <div *ngFor="let n of data.FromParties">
                {{ n }}
            </div>
        </div>
        <div class="toParties">
            <div class="toTxt">
                <b>To:</b>
            </div>
            <div *ngFor="let n of data.ToParties">
                {{ n }}
            </div>
        </div>
    </div>
    <div class="details">
        <div class="fieldname">
            Record #:
        </div>
        <div>
            {{ data.RecordNumber }}
        </div>
        <div class="fieldname">
            Date:
        </div>
        <div>
            {{ data.RecordDate }}
        </div>
        <div class="fieldname">
            Type:
        </div>
        <div>
            {{ data.DocType }}
        </div>
        <div class="fieldname">
            Book:
        </div>
        <div>
            {{ data.Book }}
        </div>
        <div class="fieldname">
            Book Type:
        </div>
        <div>
            {{ data.BookType }}
        </div>
        <div class="fieldname">
            Page:
        </div>
        <div>
            {{ data.Page }}
        </div>
        <div class="fieldname">
            Page Count:
        </div>
        <div>
            {{ data.PageCount }}
        </div>
        <div class="fieldname">
            Case Numbers:
        </div>
        <div>
            <div *ngFor="let n of data.CaseNumbers">
                {{ n }}
            </div>
        </div>
        <div class="fieldname">
            Description:
        </div>
        <div class="description">
            {{ data.Description }}
        </div>
        <div class="fieldname">
            Comments:
        </div>
        <div>
            {{ data.Comments }}
        </div>    
    </div>
    <div class="controls">
        <div class="chckbox">
            <mat-checkbox (change)="onChange($event)" [checked]="data.Exclude"  id="exclude">Add to Black List</mat-checkbox>
            <div>
                <button mat-button *ngIf="data.Exclude" (click)="onUpdateBtnClk()">Update Now</button>
            </div>
        </div>
        <div class="links">
            <div *ngFor="let n of data.Links">
                <a href="{{n.LinkText}}" target="_blank">{{ n.Type }}</a>
            </div>
        </div>
    </div>
</div>

